import type { FC } from 'react'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { RegularButton, Typography } from 'fronton-react'
import styled from 'styled-components'
import { Layout } from 'shared/components/layout/Layout'
import { useDispatch, useSelector } from 'react-redux'
import { userInfoSelector } from 'redux/selectors'
import { loadUserInfo } from 'redux/actions'
import useQuery from 'shared/hooks/useQuery'
import { AUTHORIZATION } from 'shared/consts'
import { clearCacheAndReload } from 'shared/utils/clearCacheAndReload'
import { isEmpty } from 'lodash'
import './authentication.scss'

const AuthenticationPageContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;
    bottom: 5%;
`

const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
    cursor: pointer;
`

const REACT_APP_AUTH_URL = process.env.REACT_APP_AUTH_URL || ''

export const AuthenticationPage: FC = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const query = useQuery()
    const userInfo = useSelector(userInfoSelector)
    const accessToken = localStorage.getItem('accessToken')

    useEffect(() => {
        const ticket = query.get('code')
        const isReloadApp = localStorage.getItem('isReload')

        if (ticket) {
            dispatch(loadUserInfo.request(ticket))
        }

        if (isEmpty(isReloadApp)) {
            localStorage.setItem('isReload', 'reloaded app')
            clearCacheAndReload()
        }
    }, [])

    useEffect(() => {
        if (accessToken) {
            history.push(AUTHORIZATION)
        }
    }, [userInfo, accessToken, history])

    const handleClick = () => {
        const APP_HOST = window.location.origin
        clearCacheAndReload()
        window.location.href = `${REACT_APP_AUTH_URL}${APP_HOST}`
    }

    return (
        <Layout title="Аутентификация" userInfo={userInfo}>
            <AuthenticationPageContent>
                <Typography variant="h2" style={{ fontWeight: 'bold' }}>
                    Для входа в личный кабинет необходимо пройти авторизацию
                </Typography>
                <ButtonWrapper>
                    <Typography variant="caption" style={{ paddingBottom: '10px' }}>
                        Авторизация с помощью Supplier Identifier
                    </Typography>
                    <RegularButton
                        size="m"
                        variant="accent"
                        onClick={handleClick}
                        className="keycloak-auth-btn"
                    >
                        АВТОРИЗАЦИЯ KEYCLOAK
                    </RegularButton>
                </ButtonWrapper>
            </AuthenticationPageContent>
        </Layout>
    )
}
